import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../../../utils/axios";

const initialState = {}

const userSlice = createSlice({
    name: "user",
    initialState,
    reducers: {},
    extraReducers: () => { }
});

export const { } = userSlice.actions;

export default userSlice.reducer;


/**
 * @async
 * @function verifyUserKyc
 * @description Thunk to verify user KYC details by making a POST request.
 * @param {Object} payload - The payload containing KYC details.
 * @returns {Object} - The response data or error information.
 * 
 * @example
 * dispatch(verifyUserKyc({ user_id: 1, aadhar_number: '123456789012' }))
 * fields can be added as per requirement
 */
export const verifyUserKyc = createAsyncThunk(
    'user/verifyKyc',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await axios.post('/api/v2/verification', payload);

            return {
                ...response.data,
                code: response.status
            }
        } catch (error) {
            return rejectWithValue({
                ...error?.data,
                code: error?.status
            });
        }
    }
);


/**
 * @async
 * @function updateKycDetails
 * @description Thunk to update user KYC details by making a PUT request.
 * @param {Object} param0 - The object containing id and payload.
 * @param {number} param0.id - The ID of the KYC record to update.
 * @param {Object} param0.payload - The payload containing updated KYC details.
 * @returns {Object} - The response data or error information.
 * 
 * @example
 * dispatch(updateKycDetails({ id: 1, payload: { aadhar_number: '123456789012' } }))
 * fields can be added as per requirement
 */
export const updateKycDetails = createAsyncThunk(
    'user/updateKycDetails',
    async ({ id, payload }, { rejectWithValue }) => {
        try {
            const response = await axios.post(`/api/v2/verification/${id}/documents`, payload);
            return {
                ...response.data,
                code: response.status
            }
        } catch (error) {
            return rejectWithValue({
                ...error?.data,
                code: error?.status
            });
        }
    }
);


/**
 * NOTE: This api is only for admin to fetch all users verification details.
 * @async
 * @function getVerificationsDetails
 * @description Thunk to fetch all users verification details by making a GET request.
 * @param {Object} payload - The payload containing any necessary parameters.
 * @returns {Object} - The response data or error information.
 * 
 * @example
 * dispatch(getVerificationsDetails())
 */
export const getVerificationsDetails = createAsyncThunk(
    'user/getVerificationsDetails',
    async (_, { rejectWithValue }) => {
        try {
            const response = await axios.get(`/api/v2/verification`);
            return {
                ...response.data,
                code: response.status
            }
        } catch (error) {
            return rejectWithValue({
                ...error?.data,
                code: error?.status
            });
        }
    }
)